import React from "react";
import { Button } from "reactstrap";
import { unsubscribe as unsubscribeAction } from "../../../shared/actions/subscriptionAction";
import { customConfirm, showError, showLoading, closeAlert } from "../../../shared/utils/swalHandler";
import { showSubscriptionCancelledPushToast } from "../../../shared/pusNotification/useManualToasts";
import moment from "moment";

import { SUBSCRIPTION_STATUS_REFRESH_DELAY_MS } from "../../../shared/constants/common";

const UnsubscribeModal = ({
  userInfo,
  handleCallback = () => {},
}) => {
  const handleUnsubscribe = () => {
    const ccId = userInfo?._id;
    const username = userInfo?.username;
    if (!ccId || !username) {
      showError("Error", "Creator information is missing. Please refresh and try again.", {
        confirmButtonColor: "#F334BE",
      });
      return;
    }

    const renewalDate = userInfo?.subscription?.expireAt;
    const renewalLabel =
      renewalDate && moment(renewalDate).isValid()
        ? moment(renewalDate).format("MMM DD, YYYY")
        : "your renewal date";

    customConfirm(
      `Unsubscribe from @${username}?`,
      `If you unsubscribe you will have access to this profile until ${renewalLabel}`,
      "Yes, Unsubscribe",
      "Cancel",
      { confirmButtonColor: "#6c757d", cancelButtonColor: "#f334be" }
    ).then(async (isConfirmed) => {
      if (!isConfirmed) return;

      try {
        showLoading("Cancelling subscription...");
        const result = await unsubscribeAction(ccId, false);
        if (result && result.success) {
          const successMessage =
            result.data?.message || "This subscription has been successfully canceled.";
          closeAlert();
          showSubscriptionCancelledPushToast(userInfo, successMessage);
          await new Promise((resolve) => setTimeout(resolve, SUBSCRIPTION_STATUS_REFRESH_DELAY_MS));
          await handleCallback();
        } else {
          closeAlert();
          const errorMessage = result?.error || "Something went wrong. Please try again.";
          showError("Error", errorMessage, { confirmButtonColor: "#F334BE" });
        }
      } catch (error) {
        closeAlert();
        const fallbackMessage = error?.message || "Something went wrong. Please try again.";
        showError("Error", fallbackMessage, { confirmButtonColor: "#F334BE" });
      }
    });
  };

  return (
    <>
      <Button
        className="btn-round cm_subscribed_btn"
        onClick={handleUnsubscribe}
      >
        Subscribed
      </Button>
    </>
  );
};

export default UnsubscribeModal;
